module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-[20]263.d447c0e.woff2";